export default {
    default: 'default',
    sum:     'sum',
};
